<template>
  <div v-bind:class="{'mgt':$route.params._field!='whyc'}">
    <ul>
      <li @click="handleDetail(item)" v-for="item in result.data" :key="item.artiId">
        <div>
          <img :src="item.imgUrl">
          <p v-text="item.artiName"></p>
        </div>
        <div class="mask">
          <i class="el-icon-video-play"></i>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
require("../../styles/mobile/mobile-arti-page-video.scss");
export default {
  name: "mobile-arti-page-content",
  data() {
    return {
    };
  },
  props: {
    result: {
      type: Object
    },
    field:{
      type:String
    }
  },
  methods: {
    handleDetail(item) {
        let _module="article";
        if(this.field==="song"||this.field==="zg"||this.field==="zzgs"||this.field==="zzsl"||this.field==="whjt"||this.field==="whyc"){
             let _field=this.field;
             let routeUrl = this.$router.resolve({
              path: `/mobile/arti/detail/${_module}/${_field}_detail/${item.artiId}`
           });
           window.open(routeUrl.href);
        }
    }
  },
  computed: {}
};
</script>
<style lange="sass" scoped>
  .mgt{
    margin-top: 15px;
  }
</style>

